<template>
  <div class="w-full relative center-horizontal">
    <div class="relative z-[5] asset-container w-screen" @scroll="handleScroll" ref="scrollEl" :style="{ pointerEvents: images.length > 1 ? 'auto' : 'none' }">
      <div class="assets relative flex w-max center" :style="{ padding: `0 ${padding}px 0 ${padding}px` }">
        <div class="shrink-0" v-for="x in images" :key="x" :style="{ margin: `0 ${spaceBetween}px 0 ${spaceBetween}px` }">
          <img alt="" :src="`images/${x}`" class="w-[30rem]" @load="imagesLoaded" />
        </div>
      </div>
    </div>
    <div
      v-if="images.length > 1"
      class="relative z-[10] w-fit p-[0.3rem] gap-[4rem] rounded-full flex justify-between items-center center-horizontal will-change-transform"
      :style="{ top: `${top}px`, backgroundColor: paginationBG }"
    >
      <div v-for="x in images.length" :key="x" @click="activate(x)" class="button" :class="{ carousel_nav: !icons }" :style="{ backgroundColor: !icons && active == x ? '#907d4e' : '' }">
        <div v-if="!icons">{{ String(x).padStart(2, "0") }}</div>
        <img v-if="icons" alt="" :src="`images/1x_images/${url}/icon-${x}${active == x ? '-active' : ''}.png`" :srcset="`images/2x_images/${url}/icon-${x}${active == x ? '-active' : ''}.png 2x`" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "carousel-1",
  props: {
    images: Array,
    top: { default: 0 },
    spaceBetween: { default: 0 },
    paginationBG: { default: "white" },
    icons: { default: false },
    url: { default: "" },
  },
  data() {
    return {
      active: 1,
      oneScroll: 0,
      padding: 0,
      loaded: 0,
    };
  },
  methods: {
    activate(num, animated = true) {
      if (!animated) this.active = num;
      this.$refs.scrollEl.scrollTo({ left: this.oneScroll * (num - 1), behavior: animated ? "smooth" : "instant" });
    },
    handleScroll(e) {
      var scrollAmount = this.$refs.scrollEl.scrollLeft;
      // console.log(scrollAmount);

      var calc1 = scrollAmount / this.oneScroll;
      var calc2 = Math.floor(calc1);
      var calc3 = calc1 - calc2;

      if (calc3 > 0.5) {
        this.active = calc2 + 2;
      } else {
        this.active = calc2 + 1;
      }
    },
    imagesLoaded() {
      this.loaded++;
      if (this.loaded == 1) {
        setTimeout(() => {
          const img = this.$refs.scrollEl.querySelector("img");
          this.oneScroll = img.offsetWidth;
          this.padding = (window.innerWidth - img.offsetWidth) / 2;
        }, 300);
      }
      if (this.loaded == this.images.length) {
        this.reset();
      }
    },
    reset() {
      this.active = 1;
      this.$refs.scrollEl.scrollTo({ left: 0, behavior: "instant" });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.carousel_nav {
  font-size: 1.2rem;
  font-style: italic;
  font-weight: 300;
  width: 2.7rem;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 0.12rem solid #907d4e;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "cronos-light-italic";
}
.assets > *:first-child {
  margin-left: 0 !important;
}
.assets > *:last-child {
  margin-right: 0 !important;
}
.asset-container {
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
}
.asset-container > div > div {
  scroll-snap-align: center;
  scroll-snap-stop: always;
}
.asset-container::-webkit-scrollbar {
  display: none;
}
</style>
